export default {
  columns: {
    offerName: 'Angebotsname',
    type: 'Typ',
    status: 'Status',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    details: 'Details',
    schedule: 'Zeitplan',
    startDate: 'Startdatum',
    images: 'Bild',
  },
  actions: {
    rename: 'Umbenennen',
    edit: 'Bearbeiten',
    delete: 'Loeschen',
    set_active: 'Aktivieren',
    set_inactive: 'Deaktivieren',
    cancel: 'Abbrechen',
    confirm: 'Bestaetigen',
    activate: 'Ersetzen & aktivieren',
    manage_images: 'Bild bearbeiten',
  },
  toasts: {
    offer_enabled: '{{offer}} ist jetzt das aktive Angebot fuer {{for}}',
    offer_disabled: '{{offer}} wurde auf Inaktiv gesetzt.',
    update_failed: 'Die Angebotsaktualisierung ist fehlgeschlagen.',
    successfully_deleted: 'Das Angebot wurde erfolgreich geloescht.',
    delete_failed: 'Das Entfernen des Angebots ist fehlgeschlagen.',
  },
  title: 'Alle Angebote verwalten',
  popups: {
    delete: {
      title: 'Moechten Sie dieses Angebot wirklich loeschen?',
    },
    toggle: {
      title_overlapping_is_not_allowed: 'Du kannst Master-Angebote nicht ersetzen',
      title: 'Aktives Angebot fuer diesen Zeitraum ersetzen?',
      description:
        'Sie aktivieren {{offer}} am {{weekday}}{{between}}. Dadurch wird das derzeit aktive Angebot {{currentOffer}} fuer denselben Zeitraum deaktiviert.',
      between: ', zwischen {{start}}-{{end}}',
    },
  },
};
